import React, { Component } from "react";
import AdminLoginServices from "../../services/axioServices/apiServices/AdminLoginServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faEye, faEyeSlash, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { getAuthProps, setAuthProps } from "../../utils/AuthenticationLibrary.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import { CommonValidationMessages } from "../../utils/Messages.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";

class Login extends Component {
  constructor(props) {
    super(props);
    this.adminLoginServices = new AdminLoginServices();
    this.SwalServices = new SwalServices();
    this.state = {
      showPassword: false,
      isCompanySelectPopup: false,
      isLoading: false,
      companyGroup: "",
      companies: [],
      userDetails: {},
      financialYears: [
        { yearId: 1, year: "2019-2020" },
        { yearId: 2, year: "2020-2021" },
        { yearId: 3, year: "2021-2022" },
        { yearId: 3, year: "2022-2023" },
        { yearId: 3, year: "2013-2024" },
        { yearId: 3, year: "2014-2025" },
      ],
      companyList: [],
      companyDetails: {
        companyName: "",
        financialYear: "",
      },
      userDetails: {
        email: "",
        password: "",
      },
      validState: {
        isValid: true,
        error: {
          email: "",
          password: "",
        },
        validationMessage: "",
      },
      validStateForCompany: {
        error: {
          companyName: "",
          financialYear: "",
        },
        validationMessage: "",
      },
      validationRulesForUser: {
        email: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "email"
            ),
          },
          {
            type: "email",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "valid email"
            ),
          },
        ],
        password: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "password"
            ),
          },
        ],
      },
      validationRulesForCompany: {
        companyName: [
          {
            type: "require",
            message: "Please select company",
          },
        ],
        financialYear: [
          {
            type: "require",
            message: "Please select year",
          },
        ],
      },
    };
  }

  componentDidMount() {
    // this.getCompanyForCompanySelection();
  }


  // validateFields = () => {
  //   let isValid = true;
  //   let validState = { ...this.state.validState };
  //   validState.error.email = "";
  //   validState.error.password = "";

  //   if (!this.state.userDetails.email) {
  //     validState.error.email = this.state.validationRulesForUser.email[0].message;
  //     isValid = false;
  //   }

  //   if (!this.state.userDetails.password) {
  //     validState.error.password = this.state.validationRulesForUser.password[0].message;
  //     isValid = false;
  //   }

  //   this.setState({ validState });

  //   return isValid;
  // };

  validateFields = () => {
    const newValidState = isValidForm(
      this.state.userDetails,
      this.state.validationRulesForUser,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  validateCompanyFields = () => {
    let isValid = true;
    let validStateForCompany = { ...this.state.validStateForCompany };
    validStateForCompany.error.companyName = "";
    validStateForCompany.error.financialYear = "";

    if (!this.state.companyDetails.companyName) {
      validStateForCompany.error.companyName = this.state.validationRulesForCompany.companyName[0].message;
      isValid = false;
    }

    if (!this.state.companyDetails.financialYear) {
      validStateForCompany.error.financialYear = this.state.validationRulesForCompany.financialYear[0].message;
      isValid = false;
    }

    this.setState({ validStateForCompany });

    return isValid;
  };

  getCompanyForCompanySelection = () => {
    let request = this.state.userDetails.companyId
    this.adminLoginServices.getCompanyForCompanySelection(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        const companyArray = response.responseData.map((company) => ({
          _id: company._id,
          companyName: company.CompanyName,
        }));
        this.setState({ companyList: companyArray });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getFinancialYearByCompanyName = (companyName) => {
    this.adminLoginServices.getFinancialYearByCompanyName(companyName).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {

        const financialYear = response.responseData.map((financialYear) => ({
          _id: financialYear._id,
          year: financialYear.CompanyYear,
        }));

        this.setState({ financialYears: financialYear });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  handleLogin = () => {
    if (this.validateFields()) {
      this.userAuthentication();
    }
  };

  userAuthentication = () => {
    this.setState({ isLoading: true }, () => {
      let request = this.state.userDetails;
      let currentdate = new Date();
      let currentDateTime = currentdate.getMonth() + 1 + "-" + currentdate.getDate() + "-" + currentdate.getFullYear() + " " +
        currentdate.getHours() + ":" + currentdate.getMinutes() + ":" + currentdate.getSeconds();
      request.currentDateTimeFromUserSystem = currentDateTime;
      localStorage.removeItem('MainMenu')
      localStorage.removeItem('SubMenu')
      this.adminLoginServices.userAuthentication(request).then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let authDetails = response.responseData;
          setAuthProps(authDetails);
          // window.location.href = "/Dashboard";
          this.setState({ isCompanySelectPopup: true, isLoading: false, userDetails: authDetails }, () => {
            this.getCompanyForCompanySelection()
          });
        } else {
          this.SwalServices.Error(response.Message);
          this.setState({ isLoading: false })
        }
      });
    });
  };

  resetFields = () => {
    let detail = this.state.userDetails;
    detail.email = "";
    detail.password = "";
    this.setState({ userDetails: detail });
  };

  filterCompanyName = (event) => {
    let value = event.target.value;
    let details = this.state.companyDetails;
    details.companyName = value;
    this.setState({ companyDetails: details });
  };

  selectedCompany = (e) => {
    const selectedCompany = e.target.value;
    let details = this.state.companyDetails;
    details.companyName = selectedCompany;
    this.setState({ companyDetails: details }, () => {
      this.getFinancialYearByCompanyName(selectedCompany);
    });
  };

  handleYearChange = (e) => {
    const selectedYear = e.target.value;
    let details = this.state.companyDetails;
    details.financialYear = selectedYear;
    this.setState({ companyDetails: details });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.userDetails;
    details[name] = value;
    this.setState({ userDetails: details });
  };

  userLogin = () => {
    if (this.validateCompanyFields()) {
      this.setState({ isLoading: true }, () => {
        let request = this.state.companyDetails;
        this.adminLoginServices.getCompanyDataWithCompanyNameAndYear(request).then((response) => {
          if (response.statusCode === 200 && response.responseData !== null) {
            let authDetails = getAuthProps();
            authDetails.companyName = request.companyName;
            authDetails.dbYear = response.responseData.dbName
            setAuthProps(authDetails);

            window.location.href = "/Dashboard";
          } else {
            this.SwalServices.Error(response.Message);
            this.setState({ isLoading: false })
          }
        });
      });
    }
  };

  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      this.userAuthentication();
    }
  };

  render() {
    return (
      <div className="login-page flex items-center justify-center h-screen">
        <div className="login-popup flex md:flex-row flex-col md:items-center bg-white md:rounded-[30px] rounded-[20px] md:p-5 p-[15px] lg:w-[70vw] w-[95vw] md:h-[75vh]">
          <div className="bg-blue left md:w-[45%] w-full h-full rounded-[10px] lg:p-10 md:p-[30px] p-5 flex flex-col justify-center relative overflow-hidden max-md:mb-5">
            {/* <img src="Up.svg" alt="Up" className="absolute top-0 right-0 w-[50%]" />
            <img src="Down.svg" alt="Down" className="absolute bottom-0 left-0 w-[50%]" /> */}
            <div className="lg:w-[180px] lg:h-[180px] md:w-[150px] md:h-[150px] lg:border-[35px] md:border-[25px] border-white absolute lg:bottom-10 md:bottom-[25px] lg:right-[-100px] md:right-[-90px] bg-transparent rounded-full"></div>
            <h1 className="md:text-[24px] text-[18px] font-semibold text-white">Welcome to Pharma Software</h1>
            <div className="md:w-[80px] md:h-[2.5px] w-[60px] h-[2px] bg-white mt-[5px] md:mb-[30px] mb-[20px]"></div>
            <p className="md:!text-[16px] text-[14px] text-white/90">
              Step into your workspace where you can manage entries, review updates, and keep everything on track. Sign in to continue.
            </p>
            <a
              href="https://pharma.zyden-it.com/"
              target='_blank'
              rel='noreferrer'
              className="md:mt-[30px] mt-5 bg-transparent hover:bg-white text-white hover:text-blue border-2 border-white font-medium w-fit md:px-5 md:py-2.5 px-[12px] py-[6px] md:text-[16px] text-[14px] rounded-full transition-all duration-300 ease"
            >
              Know More
            </a>
          </div>
          <div className="right md:w-[55%] w-full">
            <div className="container lg:w-[60%] md:w-[75%] mx-auto">
              <h2 className="md:text-[30px] text-[24px] font-semibold text-center">
                {/* {this.state.companyGroup !== "" ? this.state.companyGroup : ""} */}
                Login
              </h2>
              <p className="text-center text-gray-500 mt-2.5 md:!text-[15px] text-[13px]">Log in to manage your production, inventory & operations in one place.</p>
              <div className="login-box md:mt-8 mt-5">
                <div className="login-box-inner">
                  {this.state.isCompanySelectPopup === false ? (
                    <div id="loginPopUp">
                      <div className="input-group">
                        <label className="!text-gray !font-medium !mb-[2px]" htmlFor="user">Company Email</label>
                        <input
                          className={`inputFocus mb-[2px] !border-[#d7d7d7] ${this.state.validState?.error?.email ? "errorInput" : ""}`}
                          type="text"
                          id="email"
                          name="email"
                          value={this.state.userDetails.email}
                          onChange={(event) => this.handleChange(event, "email")}
                        />
                        {/* <ValidationText
                        error={this.state.validState.error.email}
                      /> */}
                      </div>
                      <div className="input-group relative">
                        <label className="!text-gray !font-medium !mb-[2px]" htmlFor="password">Password</label>
                        <input
                          // className="mb-[2px]"
                          // type="password"
                          type={this.state.showPassword ? "text" : "password"}
                          className={`inputFocus mb-[2px] !border-[#d7d7d7] ${this.state.validState?.error?.password ? "errorInput" : ""}`}
                          id="password"
                          name="password"
                          value={this.state.userDetails.password}
                          onChange={(event) => this.handleChange(event, "password")}
                          onKeyDown={(event) => this.handleKeyDown(event)}
                        />
                        <span
                          onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                          className="absolute right-3 cursor-pointer top-[30px]"
                        >
                          {this.state.showPassword ? <FontAwesomeIcon icon={faEye} className="text-black" /> : <FontAwesomeIcon icon={faEyeSlash} className="text-black" />}
                        </span>
                        {/* <ValidationText
                        error={this.state.validState.error.password}
                      /> */}
                      </div>
                      {/* <div className="input-grp w-full relative">
                      <label>Password</label>
                      <input
                        type={this.state.showPassword ? "text" : "password"}
                        id="Password"
                        name="Password"
                        className={`inputFocus ${this.state.validState?.error?.Password ? "errorInput" : ""}`}
                        autoComplete="new-password"
                        value={this.state.adminDetails.Password}
                        onChange={(event) => {
                          this.handleChange(event, "Password", "adminDetails");
                        }}
                        onBlur={() => this.setState({ showPassword: false })}
                      />
                      <span
                        onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                        className="absolute right-3 cursor-pointer top-[32px]"
                      >
                        {this.state.showPassword ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
                      </span>
                    </div> */}
                      <div className="button-group md:!mt-8 mt-[18px] flex items-center justify-center">
                        <button
                          type="submit"
                          className="search-btn !bg-blue !text-white !w-fit !px-[30px] !py-2.5"
                          disabled={this.state.isLoading}
                          onClick={this.handleLogin}

                        >
                          {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Login"}

                        </button>
                      </div>
                    </div>
                  ) : (
                    <div id="companySelectPopup" className="w-[100%] mx-auto">
                      <div className="form">
                        <div className="company-select">
                          <label className="!text-gray !font-medium !mb-[2px]" htmlFor="company-name">Company Name</label>
                          <select
                            className={`  ${this.state.validStateForCompany?.error?.companyName ? "errorInput" : ""}`}
                            id="company-name"
                            onChange={(e) => this.selectedCompany(e)}
                          >
                            <option>Select Company</option>
                            {this.state.companyList.map((company, key) => (
                              <option key={key} value={company.companyName}>
                                {company.companyName}
                              </option>
                            ))}
                          </select>
                          {/* <ValidationText
                          error={this.state.validStateForCompany.error.companyName}
                        /> */}
                        </div>
                        <div className="year-select">
                          <label
                            className=" !text-gray !font-medium !mb-[2px]  "
                            htmlFor="financial-year">Financial Year</label>
                          <select
                            className={` mb-[2px] !border-[#d7d7d7] ${this.state.validStateForCompany?.error?.financialYear ? "errorInput" : ""}`}
                            id="financial-year"
                            onChange={(e) => this.handleYearChange(e)}
                          >
                            <option>Select Year</option>
                            {this.state.financialYears.map((year, key) => (
                              <option key={key} value={year.year}>
                                {year.year}
                              </option>
                            ))}
                          </select>
                          {/* <ValidationText
                          error={this.state.validStateForCompany.error.financialYear}
                        /> */}
                        </div>
                        <div className="buttons">
                          <button
                            className="search-btn !bg-blue !text-white !w-[60px] !h-[60px] flex items-center justify-center !rounded-full"
                            onClick={() => this.userLogin()}
                            disabled={this.state.isLoading}
                          >
                            {this.state.isLoading ? <FontAwesomeIcon className="w-5 h-5 loader" icon={faSpinner} /> : < FontAwesomeIcon className="w-5 h-5" icon={faArrowRight} />}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    );
  }
}

export default Login;